import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { selectInDisplayContent } from '../../features/displayContent/selectors'
import { TopographyContent } from '../../model/model'
import {
	FirstLine,
	ImagesBox,
	SecondLine,
	ThirdLine,
	TitleWrapper,
	Wrapper,
} from './CommonComponents'
import MediaBox from './MediaBox'

const isTopographyContent = (content?: any): content is TopographyContent =>
	content?.section === 'topography'

export const Topography: React.FC = () => {
	const { t } = useTranslation()
	const displayContent = useSelector(selectInDisplayContent)

	const data = displayContent?.data
	return (
		<Wrapper>
			<TitleWrapper>
				<FirstLine>{t('content.clinicalData')}</FirstLine>
				<SecondLine>{t('content.topography')}</SecondLine>
				<ThirdLine>{t('content.topographyInfo')}</ThirdLine>
			</TitleWrapper>
			{isTopographyContent(data) && (
				<ImagesBox className="vertical">
					<MediaBox media={data.content.OD} />
					<MediaBox media={data.content.OS} />
				</ImagesBox>
			)}
		</Wrapper>
	)
}

export default Topography
